import _ from 'underscore';

import { LocationMapper } from '~src/personalSpace/model/mappers/LocationMapper';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { IViewUsageInfo } from '~src/spacesPlatform/models/IUsageInfo';
import { IIdItem } from '~src/spacesPlatform/models/resourceParts';
import { UserMapper } from '~src/userManagement/users/models/mappers/UserMapper';
import { ViewMapper } from '~src/views/mappers/ViewMapper';
import { IGetViewsResult } from '~src/views/ServerApi/requests/GetViewsRequest';
import { WorkbookMapper } from '~src/workbook/models/mappers/WorkbookMapper';

import { IBroadcastDetail, IGetDetailBroadcastResult } from '../models/BroadcastModels';
import { BroadcastRestGetResponse } from '../models/BroadcastRestApiModels';
import { IGetBroadcastsResult } from './requests/GetBroadcastViewsRequest';

export module BroadcastServerApiHelper {

    export function mapViewsFromResult(result: IGetBroadcastsResult | IGetViewsResult): IContentInfo[] {
        if (result?.views?.length > 0) {
            // This check for favorites can be removed when the broadcastUIRest FF is removed
            const favoriteViews = isGetBroadcastResult(result) ? result.viewFavorites : result.favorites;
            const users = index(UserMapper.map(result.users));
            const locations = LocationMapper.map(result.containers);
            const workbooks = index(WorkbookMapper.mapParents(result.workbooks, users, {}, locations));
            const views = ViewMapper.map(result.views, workbooks, <IViewUsageInfo>{}, favorites(favoriteViews));
            return views;
        }
        return [];
    }

    function isGetBroadcastResult(result: IGetBroadcastsResult | IGetViewsResult): result is IGetBroadcastsResult {
        return (result as IGetBroadcastsResult).viewFavorites !== undefined;
    }

    function index<T extends IIdItem>(items: ReadonlyArray<T>): _.Dictionary<T> {
        return _.indexBy(items, 'id');
    }

    function favorites(ids: string[]) {
        return _.indexBy(ids, _.identity);
    }

    export function broadcastDetail(result: IGetDetailBroadcastResult): IBroadcastDetail {
        const broadcastItem = {
            id: result.id,
            workbookId: result.workbookId,
            workbookLuid: result.workbookLuid,
            broadcastWorkbookName: result.broadcastWorkbookName,
            viewId: result.viewId,
            viewLuid: result.viewLuid,
            broadcastViewName: result.broadcastViewName,
            publicFacingUrl: result.publicFacingUrl,
        };
        return broadcastItem;
    }

    export function mapGetBroadcastRestResponseToIBroadcast(response: BroadcastRestGetResponse): IGetDetailBroadcastResult {
        const broadcastView = response?.broadcastView;
        const view = broadcastView?.view;
        const workbook = view?.workbook;

        const broadcastResult: IGetDetailBroadcastResult = {
            workbookLuid: workbook?.id,
            broadcastWorkbookName: workbook?.name,
            viewLuid: view?.id,
            broadcastViewName: view?.name,
            publicFacingUrl: broadcastView?.url
        };

        return broadcastResult;
    }

}
